import { render, staticRenderFns } from "./SupplyGoods.vue?vue&type=template&id=2cc49d3a&scoped=true&"
import script from "./SupplyGoods.vue?vue&type=script&lang=js&"
export * from "./SupplyGoods.vue?vue&type=script&lang=js&"
import style0 from "./SupplyGoods.vue?vue&type=style&index=0&id=2cc49d3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc49d3a",
  null
  
)

export default component.exports